import React, { useState, useEffect } from 'react';
import { Save, Plus, Trash2 } from 'lucide-react';
import api from '../../api';
import { toast } from 'sonner';
import { Input } from './NewsManager';

const iconOptions = ['ball', 'hoop', 'ribbon', 'rope', 'clubs'];

const ContentManager = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => { api.get('/site-config').then((r) => setConfig(r.data)); }, []);
  if (!config) return <p className="text-white/50">Chargement...</p>;

  const content = config.content || {};
  const whatIsGR = content.whatIsGR || { intro: '', description: '', apparatus: [] };
  const clubDescription = content.clubDescription || '';

  const setContent = (patch) => setConfig({ ...config, content: { ...content, ...patch } });
  const setWG = (patch) => setContent({ whatIsGR: { ...whatIsGR, ...patch } });

  const save = async () => {
    try {
      await api.put('/site-config', { content: { ...(config.content || {}), whatIsGR, clubDescription } });
      toast.success('Contenu enregistré');
    } catch (e) { toast.error('Erreur'); }
  };

  const updateApp = (i, k, v) => { const a = [...(whatIsGR.apparatus || [])]; a[i] = { ...a[i], [k]: v }; setWG({ apparatus: a }); };
  const addApp = () => setWG({ apparatus: [...(whatIsGR.apparatus || []), { name: '', icon: 'ball', description: '' }] });
  const removeApp = (i) => setWG({ apparatus: (whatIsGR.apparatus || []).filter((_, idx) => idx !== i) });

  return (
    <div data-testid="content-manager">
      <h2 className="text-2xl font-bold text-white mb-8">Contenu des pages</h2>
      <div className="space-y-10 max-w-4xl">

        {/* Notre Club */}
        <section>
          <h3 className="text-lg font-semibold text-white mb-3">Notre Club – Description</h3>
          <p className="text-white/50 text-xs mb-2">Utilisez des sauts de ligne (Entrée) pour créer des paragraphes.</p>
          <Input value={clubDescription} onChange={(v) => setContent({ clubDescription: v })} textarea testId="club-description-input" />
        </section>

        {/* La GR */}
        <section>
          <h3 className="text-lg font-semibold text-white mb-3">Page "Qu'est-ce que la GR ?"</h3>
          <div className="space-y-4">
            <Input label="Titre d'introduction" value={whatIsGR.intro || ''} onChange={(v) => setWG({ intro: v })} testId="whatisgr-intro-input" />
            <Input label="Description" value={whatIsGR.description || ''} onChange={(v) => setWG({ description: v })} textarea testId="whatisgr-description-input" />
          </div>

          <div className="mt-6">
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-white font-medium">Les 5 engins</h4>
              <button onClick={addApp} className="flex items-center gap-1 text-fuchsia-400 text-sm"><Plus size={16} /> Ajouter</button>
            </div>
            {(whatIsGR.apparatus || []).map((a, i) => (
              <div key={i} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_2fr_auto] gap-2 mb-3 items-end">
                <Input label={i === 0 ? 'Nom' : ''} value={a.name || ''} onChange={(v) => updateApp(i, 'name', v)} placeholder="Ballon" />
                <div>
                  {i === 0 && <label className="block text-white/70 text-sm mb-2">Icône</label>}
                  <select value={a.icon || 'ball'} onChange={(e) => updateApp(i, 'icon', e.target.value)} className="w-full bg-white/5 border border-white/10 rounded-lg py-2 px-3 text-white focus:border-fuchsia-500/50 focus:outline-none">
                    {iconOptions.map((o) => <option key={o} value={o} className="bg-neutral-900">{o}</option>)}
                  </select>
                </div>
                <Input label={i === 0 ? 'Description' : ''} value={a.description || ''} onChange={(v) => updateApp(i, 'description', v)} />
                <button onClick={() => removeApp(i)} className="p-3 text-white/60 hover:text-red-400"><Trash2 size={18} /></button>
              </div>
            ))}
          </div>
        </section>

        <button onClick={save} data-testid="save-content-btn" className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-fuchsia-500 to-pink-500 rounded-lg text-white font-medium"><Save size={18} /> Enregistrer</button>
      </div>
    </div>
  );
};

export default ContentManager;
